<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <ulu-date-picker
            v-model="newDate"
            lang="en"
            format="DD.MM.YYYY"
            :clearable="false"
            :placeholder="$t('globals.set_new_starting_date')"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            size="sm"
            @click="saveNewStartDate()"
            variant="success"
            :disabled="newDate.length == 0"
          >
            {{ $t("globals.confirm") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            size="sm"
            @click="cancel"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {
    "ulu-date-picker": () => import("vue2-datepicker")
  },
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      newDate: "",
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    saveNewStartDate() {
      this.newDate.setHours(this.newDate.getHours() + 1);
      const date = this.newDate.toISOString().substring(0, 10);

      const data = {
        query: `
          mutation { 
            res: InquiryUpdateStartDate(
              inquiry_id: ${this.$route.params.id},
              new_date: "${date}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancel();
      });
    },
    cancel() {
      this.newDate = "";
      this.close();
    }
  }
};
</script>
